import request from '@/utils/request'

export const getUserInfoDetail = () => {
  return request.get('/user/info')
}

// 修改个人资料（昵称 / 头像，按传入字段增量更新）
export const updateProfileApi = ({ nickname, avatar }) => {
  const data = {}
  if (typeof nickname !== 'undefined') data.nickname = nickname
  if (typeof avatar !== 'undefined') data.avatar = avatar
  return request.post('/user/updateProfile', data)
}

// 上传头像（复用通用图片上传接口，返回 { url }）
export const uploadAvatarApi = (file) => {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/upload/image', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

// 发送「绑定手机号」短信验证码
export const sendBindCodeApi = (mobile) => {
  return request.post('/user/sendBindCode', { mobile })
}

// 绑定 / 更换手机号
export const bindMobileApi = (mobile, smsCode) => {
  return request.post('/user/bindMobile', { mobile, smsCode })
}

// 提交投诉反馈（发送邮件通知管理员）
export const submitComplaintApi = (data) => {
  return request.post('/complaint/submit', {
    title: data.title,
    content: data.content,
    contact: data.contact
  })
}
